import PropTypes from 'prop-types';
// material
import { Box, Stack, Typography } from '@mui/material';
// components
import Iconify from './Iconify';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 3, px: 2 }} {...other}>
      <Box
        sx={{
          width: 48,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          color: 'text.disabled',
          bgcolor: 'background.neutral',
        }}
      >
        <Iconify icon="eva:search-fill" width={22} height={22} />
      </Box>
      <Typography variant="subtitle1">Nothing found</Typography>
      <Typography variant="body2" align="center" sx={{ color: 'text.secondary', maxWidth: 320 }}>
        {searchQuery ? (
          <>
            No results for <strong>&quot;{searchQuery}&quot;</strong>. Try checking for typos or using complete
            words.
          </>
        ) : (
          'Start typing to search.'
        )}
      </Typography>
    </Stack>
  );
}
